/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Projection_Year_ZeroInputs */

const en_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year 0`)
};

const de_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahr 0`)
};

const pt_br2_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano 0`)
};

const tr_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0. Yıl`)
};

const zh_cn2_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第0年`)
};

const zh_hk2_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第0年`)
};

const ko_kr2_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0년 차`)
};

const ru_ru2_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Год 0`)
};

const es_419_onboarding_v1_projection_year_zero = /** @type {(inputs: Onboarding_V1_Projection_Year_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Año 0`)
};

/**
* | output |
* | --- |
* | "Year 0" |
*
* @param {Onboarding_V1_Projection_Year_ZeroInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_projection_year_zero = /** @type {((inputs?: Onboarding_V1_Projection_Year_ZeroInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Projection_Year_ZeroInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_projection_year_zero(inputs)
	if (locale === "de") return de_onboarding_v1_projection_year_zero(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_projection_year_zero(inputs)
	if (locale === "tr") return tr_onboarding_v1_projection_year_zero(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_projection_year_zero(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_projection_year_zero(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_projection_year_zero(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_projection_year_zero(inputs)
	return es_419_onboarding_v1_projection_year_zero(inputs)
});